import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";

const Default = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  return (
    <div className="container">
      <p>{t("DETAIL.TEMPLATES.ACORIS_COLLECTIVE.UNKNOWN_STEP")}</p>
    </div>
  );
};

export default Default;
